<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <h3 style="cursor: pointer" @click="home()">Sistema Geral de Participações</h3>
      <b-navbar-nav class="ml-auto">
        <b-nav-item class="d-md-down-none"></b-nav-item>
        <DefaultHeaderDropdownAccnt/>
        <b-nav-item></b-nav-item>
      </b-navbar-nav>
      <!--<AsideToggler class="d-none d-lg-block" />-->
     <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <ModalConferenciaPerfil />
  </div>
</template>

<script>
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from '@/templates/containers/DefaultAside'
import DefaultHeaderDropdown from '@/templates/containers/DefaultHeaderDropdown'
import DefaultHeaderDropdownAccnt from '@/templates/containers/DefaultHeaderDropdownAccnt'
import DefaultHeaderDropdownMssgs from '@/templates/containers/DefaultHeaderDropdownMssgs'
import DefaultHeaderDropdownTasks from '@/templates/containers/DefaultHeaderDropdownTasks'
import SessionStorage from '@/services/session-storage'
import ModalConferenciaPerfil from '@/components/shared/ModalConferenciaPerfil'

export default {
  name: 'SiteTemplate',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdown,
    DefaultHeaderDropdownMssgs,
    DefaultHeaderDropdownTasks,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    ModalConferenciaPerfil
  },
  created () {
    let usuario = SessionStorage.get('usuario')

    if (!usuario) {
      this.$router.push('/externa')
    }
    this.$store.dispatch('atualizarPermissoes')
  },
  computed: {
    nav () {
      let news = []

      let home = {
        name: 'Apresentação',
        url: '/administrativa',
        icon: 'fa fa-home'
      }
      news.push(home)

      // let sala = {
      //   name: 'Gerenciar Salas de Transmissões',
      //   url: '/sala',
      //   icon: 'fa fa-tv'
      // }

      // news.push(sala)

      let conferencias = {
        name: 'Conferências',
        url: '/conferencias',
        icon: 'fa fa-users'
      }
      news.push(conferencias)

      let area = {
        name: "Gerenciar Áreas",
        url: "/areas",
        icon: "fa fa-book",
      };

      news.push(area);
      
      let usuarios = {
        name: 'Usuários',
        url: '/usuarios',
        icon: 'fa fa-user'
      }
      let configuracao = {
        name: 'Configuração',
        icon: 'fa fa-wrench',
        children: [usuarios]
      }

      news.push(configuracao)

    //  let documento = {
    //     name: 'Gerenciar Documentos',
    //     url: '/arquivos',
    //     icon: 'fa fa-book'
    //   }

    //   news.push(documento)

      return news
    },
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label)
    }
  },
  methods: {
    home () {
      this.$router.push({path: '/autenticada'})
    },
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    }
  }
}
</script>

<style lang="scss" scoped>
  // CoreUI Icons Set
  @import '@coreui/icons/css/coreui-icons.min.css';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  @import 'flag-icon-css/css/flag-icon.min.css';
  /* Import Bootstrap Vue Styles */
  @import 'bootstrap-vue/dist/bootstrap-vue.css';
  // Import Main styles for this application
  @import '../../assets/scss/style';
</style>



// WEBPACK FOOTER //
// src/templates/site-interno/ModeloAdministrativo.vue